import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowTrendDown,
  faArrowTrendUp,
} from '@fortawesome/pro-regular-svg-icons';
import { Text } from '@querodelivery/uni-react';
import { Skeleton } from '@/_config/lib/react-native-skeleton';
import { EIndicatorTrend } from '../../constants';
import type { MonitorIndicator } from '../../types';
import styles from './indicators.module.scss';

const EMPTY_VALUE = '—';

interface KpiCardProps {
  label: string;
  indicator?: MonitorIndicator;
  isLoading: boolean;
  higherIsBetter: boolean;
}

export function KpiCard({
  label,
  indicator,
  isLoading,
  higherIsBetter,
}: KpiCardProps) {
  if (isLoading) {
    return <Skeleton height={40} borderRadius={16} />;
  }

  const isUp = indicator?.trend === EIndicatorTrend.UP;
  const isPositive = isUp === higherIsBetter;
  const variation = (indicator?.trend && indicator.variation) ?? null;

  return (
    <div className={styles.card}>
      <span className={styles.content}>
        <Text
          as="span"
          fontSize="sm"
          fontWeight="medium"
          tone="secondary"
          className={styles.label}
        >
          {label}:
        </Text>
        <span className={styles.value}>
          <Text
            as="span"
            fontSize="lg"
            fontWeight="bold"
            tone="secondary"
            className={styles.number}
          >
            {indicator ? indicator.value.toLocaleString('pt-BR') : EMPTY_VALUE}
          </Text>
          {indicator?.unit && (
            <Text as="span" fontSize="xs" tone="supporting">
              {indicator.unit}
            </Text>
          )}
        </span>
      </span>

      {variation !== null && (
        <span
          className={styles.variation}
          data-sentiment={isPositive ? 'positive' : 'negative'}
        >
          <FontAwesomeIcon
            icon={isUp ? faArrowTrendUp : faArrowTrendDown}
            className={styles.trendIcon}
          />
          <Text as="span" fontSize="xs" fontWeight="medium" tone="inherit">
            {Math.abs(variation)}%
          </Text>
        </span>
      )}
    </div>
  );
}
